import { render, staticRenderFns } from "./AcademicTrainingAddEdit.vue?vue&type=template&id=c2297ec6"
import script from "./AcademicTrainingAddEdit.vue?vue&type=script&lang=js"
export * from "./AcademicTrainingAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports